import React from "react";
import { FormGroup, Label } from "reactstrap";
import Cancel from "../../assets/images/cancel.svg";

interface AutoCompleteDropDownProps {
  label: string;
  dropdownRef: any;
  isDropdownOpen: boolean;
  placeholder: string;
  filteredArray: any;
  formValue: any;
  searchValue: any;
  isRequired: string;
  disabled?: boolean;
  setSearchValue: (value: any) => void;
  setIsDropdownOpen: (value: any) => void;
  handleChange: (value: any) => void;
  clearable: boolean;
}
const AutoCompleteDropDown: React.FC<AutoCompleteDropDownProps> = ({
  label,
  dropdownRef,
  isDropdownOpen,
  placeholder,
  filteredArray,
  searchValue,
  isRequired,
  formValue,
  disabled,
  setSearchValue,
  setIsDropdownOpen,
  handleChange,
  clearable,
}) => {
  return (
    <FormGroup className="formgroup">
      <Label className="custom-label">
        {label}
        {isRequired && <span className="required-asterisk">*</span>}
      </Label>
      <div
        ref={dropdownRef}
        className={`custom-dropdown ${isDropdownOpen ? "active" : ""}`}
      >
        <div
          className="dropdown-button"
          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
        >
          <input
            type="text"
            className={disabled ? "dropdown-input-disabled" : "dropdown-input"}
            value={searchValue}
            onChange={(e: any) => {
              setSearchValue(e.target.value);
              setIsDropdownOpen(true);
            }}
            onClick={() => setIsDropdownOpen(true)}
            placeholder={placeholder}
            autoComplete="no_check"
            disabled={disabled}
          />
          <div className="dropdown-button-child">
            {clearable && (
              <img
                src={Cancel}
                alt="Clear"
                className="clear-drop-down"
                onClick={(e) => {
                  e.stopPropagation();
                  handleChange("");
                  setSearchValue("");
                  setIsDropdownOpen(false);
                }}
              />
            )}
          </div>
          <img
            src={require("../../assets/images/375_vector.svg").default}
            alt="Dropdown Icon"
            className="dropdown-icon"
          />
        </div>

        {isDropdownOpen && (
          <div className="dropdown-content">
            {filteredArray.length > 0 ? (
              filteredArray.map((state) => (
                <label key={state}>
                  <input
                    type="radio"
                    name="state"
                    value={state}
                    checked={state === formValue}
                    autoComplete="off"
                    onChange={() => {
                      handleChange(state);
                      setIsDropdownOpen(false); // Close dropdown after selection
                    }}
                  />
                  {state}
                </label>
              ))
            ) : (
              <div className="no-results">No results found</div>
            )}
          </div>
        )}
      </div>
    </FormGroup>
  );
};
export default AutoCompleteDropDown;
